import { Action } from "@ngrx/store";

export enum NodeNotesActionTypes {
  INIT_NODES_WITH_NOTES = 'Init set of nodes with notes',
  ADD_NODE_WITH_NOTES = 'Add node with notes',
  ACTIVE_NODE_NOTES_PANEL = "Active node notes panel"
}

export class InitNodesWithNotesAction implements Action {
  readonly type = NodeNotesActionTypes.INIT_NODES_WITH_NOTES;
  constructor(public payload: { nodeIds: Set<string> }){}
}
export class AddNodeWithNotesAction implements Action {
  readonly type = NodeNotesActionTypes.ADD_NODE_WITH_NOTES;
  constructor(public payload: { nodeId: string }){}
}
export type NodeNotesAction = InitNodesWithNotesAction | AddNodeWithNotesAction;

export class ActiveNodeNotesPanelAction implements Action {
  readonly type = NodeNotesActionTypes.ACTIVE_NODE_NOTES_PANEL;
  constructor(public payload: { nodeId: string }){}
}
